'use client';
import Tags from "@/components/common/Tags";
import ImageGallery from "@/components/common/image-gallery";
import { PostContentFallback, useLoadPostBySlug } from "@/components/common/posts/posts.provider";
import { SimilarPosts } from "@/components/common/posts/similar-posts";
import SectionPage from "@/components/common/section-page";

export default function PostPage() {
    const {currentPost, postsBasePath} = useLoadPostBySlug("2026/09/nollywood-meets-cote-divoire");

    return (
        <PostContentFallback>
            <article>
                <div style={{ backgroundImage: `url(${currentPost?.image})` }} className={"h-[400px] w-full bg-cover bg-center relative"}>
                    <div className={"bg-bleu-marine h-[100px] w-full flex items-center justify-start absolute bottom-0"}>
                        <SectionPage sectionType={"2xl"}>
                            <h1 className={"text-white text-4xl font-exo"}>{currentPost?.title}</h1>
                        </SectionPage>
                    </div>
                </div>

                <SectionPage sectionType={"xl"} className={"my-12"}>
                    <div className="markdown-content text-gray-800">
                        <p className="my-4 text-normal leading-relaxed">
                            La Côte d’Ivoire accueille une délégation de professionnels de l’industrie cinématographique nigériane dans le cadre de « Nollywood Meets Côte d’Ivoire », une initiative visant à renforcer les passerelles entre cinéma, culture et tourisme.
                        </p>

                        <p className="my-4 text-normal leading-relaxed">
                            Le 9 septembre, Madame Malékah MOURAD-CONDE, Directrice Générale de Côte d’Ivoire Tourisme, a accueilli en Côte d’Ivoire une délégation de personnalités de l’industrie cinématographique nigériane composée de Michael Dappa, Cynthia Clarke, Ehis Perfect et Chudy Davidson.
                        </p>

                        <p className="my-4 text-normal leading-relaxed">
                            Cette visite s’inscrit dans le cadre de « Nollywood Meets Côte d’Ivoire », une semaine dédiée aux échanges, aux rencontres professionnelles et à la découverte de plusieurs sites et expériences touristiques de la destination ivoirienne.
                        </p>

                        <p className="my-4 text-normal leading-relaxed">
                            À travers cette initiative, la Côte d’Ivoire et le Nigeria entendent créer de nouvelles opportunités de collaboration entre leurs industries cinématographiques respectives, tout en mettant en lumière le rôle du cinéma comme vecteur de promotion touristique et culturelle.
                        </p>

                        <p className="my-4 text-normal leading-relaxed">
                            Le programme a notamment été marqué par une conférence de presse, suivie d’un dîner-gala organisé au Radisson Blu Abidjan, en présence de Son Excellence Monsieur Ezenwa NWAOBIALA, Ambassadeur du Nigeria en Côte d’Ivoire.
                        </p>

                        <p className="my-4 text-normal leading-relaxed">
                            Après cette étape abidjanaise, la délégation poursuivra son immersion à Yamoussoukro, capitale politique de la Côte d’Ivoire, pour la suite de son programme de découverte.
                        </p>

                        <p className="my-4 text-normal leading-relaxed">
                            Cette rencontre constitue une nouvelle étape dans le rapprochement entre la Côte d’Ivoire et le Nigeria. Elle témoigne de la volonté de développer davantage les synergies entre tourisme, culture et industrie cinématographique, tout en favorisant les échanges entre les acteurs des deux pays.
                        </p>

                        <p className="my-4 text-normal leading-relaxed">
                            À travers « Nollywood Meets Côte d’Ivoire », la destination ivoirienne affirme ainsi son ambition de renforcer son attractivité et de s’ouvrir davantage aux collaborations internationales, en s’appuyant notamment sur la puissance du cinéma et de la création audiovisuelle pour faire découvrir ses territoires, son patrimoine et ses expériences touristiques.
                        </p>

                        <div className={'my-8'}>
                            <ImageGallery images={
                                Array.from({ length: 18 }).map((_, index) => ({
                                    src: `/images${postsBasePath}/${String(currentPost?.slug)}/${index + 1}.jpg`,
                                    alt: `image${index + 1}`,
                                    width: 700,
                                    height: 700,
                                }))
                            } aspectRatio={"video"} />
                        </div>

                        <Tags tags={['Nollywood', 'Cinéma', 'Nigeria', 'CôtedIvoire', 'Tourisme', 'Culture', 'CôtedIvoireTourisme', 'GrandBassam', 'Abidjan']} />
                    </div>

                    <SimilarPosts currentSlug={String(currentPost?.slug)} />
                </SectionPage>
            </article>
        </PostContentFallback>
    );
}
